import React from "react";
import {MM_QUESTION} from "../../scripts/myga-model";
import {validateCondition} from "../../scripts/validation";

function QuestionTextArea(props) {
  
  const {data, question, handleChange, required, responseClass} = props;

  const response = question.response[MM_QUESTION.response.constraints][0] || {};
  // const vOrientation = question[MM_QUESTION.visualOrientation];
  // const qCols = (vOrientation===QUESTION_VISUAL_ORIENTATION.horizontal) ? 6 : 12;
  // const aCols = (qCols<12) ? 12 - qCols : 12;
  const taRows = response.rows || 3;
  const taCols = response.cols || 'auto';
  const taMaxLength = response.maxLength || 300;
  const disabled = !validateCondition(question.enableCondition,data) || !validateCondition(response.enableCondition,data);

  return (
      <textarea
        className={`${responseClass}`}
        id={question.key}
        name={question.key}
        value={data[question.key]}
        onChange={handleChange(question.key)}
        required={required}
        disabled={disabled}
        rows={taRows}
        cols={taCols}
        maxLength={taMaxLength}
        style={{width: '100%'}}
      />
  );
}

export default QuestionTextArea;